import { Injectable } from "@angular/core";

import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { map, switchMap, catchError } from "rxjs/operators";

import * as directOnboardingActions from "../actions/direct-onboarding.actions";
import * as fromServices from "../../services";

@Injectable()
export class DirectOnboardingEffects {
  constructor(
    private actions$: Actions,
    private uwlService: fromServices.UwlService,
  ) {}

  loadDirectOnboardingConfigs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(directOnboardingActions.LOAD_DIRECT_ONBOARDING_CONFIGS),
      switchMap(() => {
        return this.uwlService.findAllDirectOnboardingConfigs().pipe(
          map(
            (response) =>
              new directOnboardingActions.LoadDirectOnboardingConfigsSuccess(response.body),
          ),
          catchError((error) =>
            of(new directOnboardingActions.LoadDirectOnboardingConfigsFail(error)),
          ),
        );
      }),
    );
  });

  createDirectOnboardingConfig$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(directOnboardingActions.CREATE_DIRECT_ONBOARDING_CONFIG),
      map(
        (action: directOnboardingActions.CreateDirectOnboardingConfig) => action.payload,
      ),
      switchMap((config) => {
        return this.uwlService.createDirectOnboardingConfig(config).pipe(
          map(
            (response) =>
              new directOnboardingActions.CreateDirectOnboardingConfigSuccess(response.body),
          ),
          catchError((error) =>
            of(new directOnboardingActions.CreateDirectOnboardingConfigFail(error)),
          ),
        );
      }),
    );
  });

  updateDirectOnboardingConfig$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(directOnboardingActions.UPDATE_DIRECT_ONBOARDING_CONFIG),
      map(
        (action: directOnboardingActions.UpdateDirectOnboardingConfig) => action.payload,
      ),
      switchMap((config) => {
        return this.uwlService.updateDirectOnboardingConfig(config).pipe(
          map(
            (response) =>
              new directOnboardingActions.UpdateDirectOnboardingConfigSuccess(response.body),
          ),
          catchError((error) =>
            of(new directOnboardingActions.UpdateDirectOnboardingConfigFail(error)),
          ),
        );
      }),
    );
  });

  deleteDirectOnboardingConfig$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(directOnboardingActions.DELETE_DIRECT_ONBOARDING_CONFIG),
      map(
        (action: directOnboardingActions.DeleteDirectOnboardingConfig) => action.payload,
      ),
      switchMap((config) => {
        return this.uwlService.deleteDirectOnboardingConfig(config.id).pipe(
          map(() => new directOnboardingActions.DeleteDirectOnboardingConfigSuccess(config)),
          catchError((error) =>
            of(new directOnboardingActions.DeleteDirectOnboardingConfigFail(error)),
          ),
        );
      }),
    );
  });
}
